import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject, distinctUntilChanged, startWith, takeUntil } from 'rxjs';
import { PayeeCasesService } from 'src/app/shared/payee-cases/payee-cases.service';
import { PayeeFormFieldComponent } from '../../../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';

@Component({
  selector: 'app-bulk-upload-filter',
  templateUrl: './bulk-upload-filter.component.html',
  styleUrls: ['./bulk-upload-filter.component.scss'],
  imports: [PayeeFormFieldComponent, FormsModule, ReactiveFormsModule],
})
export class BulkUploadFilterComponent implements OnInit, OnDestroy {
  private payeeCasesService = inject(PayeeCasesService);

  private readonly destroy = new Subject<void>();
  readonly bulk_upload_name = new FormControl<string | null>(null);

  ngOnInit(): void {
    this.payeeCasesService.bulk_upload_name
      .pipe(
        startWith(this.payeeCasesService.bulk_upload_name.value),
        takeUntil(this.destroy),
        distinctUntilChanged(),
      )
      .subscribe((v) =>
        this.bulk_upload_name.patchValue(v, { emitEvent: false }),
      );

    this.bulk_upload_name.valueChanges
      .pipe(takeUntil(this.destroy), distinctUntilChanged())
      .subscribe((v) => this.payeeCasesService.bulk_upload_name.next(v));
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
